<app-spinner *ngIf="loading"></app-spinner>

<div *ngIf="!loading" class="container">
  <div class="list">
    <button class="item" [mdTooltip]="translationType.percentTranslated + '% translated'" mdTooltipPosition="right"
      md-raised-button *ngFor="let translationType of translationTypes"
      [color]="activeTranslationType && activeTranslationType.id === translationType.id ? 'accent': ''"
      [routerLink]="['/translate', translationType.id]" routerLinkActive="active">
      {{translationType.value}}
    </button>
  </div>
  <md-card>
    <router-outlet></router-outlet>
  </md-card>
</div>


// WEBPACK FOOTER //
// ./src/app/pages/translate/translate.component.html